// Lookup lists for the entity pickers of the Zásilky module. They reuse the EXISTING ERP lists
// (/api/customers, /api/suppliers, /api/machines, /api/orders); there is no lookup API of its own.
// Lists are cached for a short while, so opening several pickers does not repeat the requests.

const KINDS = {
  customer: { url: '/api/customers?limit=1000', label: (r) => r.company_name || r.school_name || `Zákazník ${r.id}`, hint: (r) => r.city || '' },
  supplier: { url: '/api/suppliers?limit=1000', label: (r) => r.name || `Dodavatel ${r.id}`, hint: (r) => r.contact_person || '' },
  machine: {
    url: '/api/machines?limit=1000',
    label: (r) => [r.model_type, r.serial_number].filter(Boolean).join(' · ') || `Trenažér ${r.id}`,
    hint: (r) => r.customer_name || '',
  },
  order: { url: '/api/orders?limit=500', label: (r) => r.order_number || `Objednávka ${r.id}`, hint: (r) => r.customer_name || '' },
};

export const ENTITY_KINDS = Object.keys(KINDS);

const TTL_MS = 60_000;
const cache = new Map(); // kind -> { at, promise }

async function fetchKind(kind) {
  const cfg = KINDS[kind];
  const res = await fetch(cfg.url, { credentials: 'include' });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) throw new Error('Seznam se nepodařilo načíst.');
  const rows = Array.isArray(json.data) ? json.data : [];
  return rows
    .filter((r) => Number.isInteger(Number(r.id)))
    .map((r) => ({ id: Number(r.id), label: cfg.label(r), hint: cfg.hint(r) }));
}

// Resolves with [{ id, label, hint }] (plain text only)
export function loadEntities(kind) {
  const hit = cache.get(kind);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = fetchKind(kind).catch((err) => {
    cache.delete(kind);
    throw err;
  });
  cache.set(kind, { at: Date.now(), promise });
  return promise;
}
